// World dimensions — virtual world is 2x canvas, rendered at 0.75x zoom.
// CANVAS_WIDTH is dynamic: wider on wide-aspect devices (phones, ultrawides)
// to fill the screen instead of letterboxing. Extra width = gutter space for
// touch controls; camera bounds prevent showing extra game content.
let _canvasWidth = 1920;
let _worldWidth = 2560;
let _worldHeight = 1440;

/** Set canvas width before game.init(). Called once at boot from main.ts. */
export function setCanvasWidth(w: number): void {
  _canvasWidth = w;
}

/** Set world width before generateTerrain(). Called from terrain generation when stage has custom worldWidth. */
export function setWorldWidth(w: number): void {
  _worldWidth = w;
}

/** Set world height before resetGame(). Call setWorldHeight(ASCENT.WORLD_HEIGHT) for ascent mode, setWorldHeight(1440) for standard. */
export function setWorldHeight(h: number): void {
  _worldHeight = h;
}

export const WORLD = {
  get CANVAS_WIDTH() { return _canvasWidth; },
  CANVAS_HEIGHT: 1080,
  get VIRTUAL_WIDTH() { return _worldWidth; },  // dynamic — default 2560, wider for wide stages
  get VIRTUAL_HEIGHT() { return _worldHeight; },
  SCALE: 0.75,
  WALL_MARGIN: 20,
  get WORLD_LEFT() { return this.WALL_MARGIN; },
  get WORLD_RIGHT() { return this.VIRTUAL_WIDTH - this.WALL_MARGIN; },
  CEILING_HEIGHT: -3000,    // far above visible area — functionally invisible
  get WORLD_TOP() { return this.CEILING_HEIGHT; },
  get WORLD_BOTTOM() { return _worldHeight; },
  /** World-space width visible on screen (canvas pixels / zoom). */
  get VISIBLE_WIDTH() { return _canvasWidth / 0.75; },
} as const;

// Terrain grid
export const TERRAIN = {
  CELL_SIZE: 2,
  get GRID_WIDTH() { return _worldWidth / 2; },  // VIRTUAL_WIDTH / CELL_SIZE (dynamic)
  get GRID_HEIGHT() { return _worldHeight / 2; },  // VIRTUAL_HEIGHT / CELL_SIZE (dynamic)
  FILL_COLOR: 0x050510,
  EDGE_COLOR: 0x00ffff,
  FILL_R: 5, FILL_G: 5, FILL_B: 16,
  EDGE_OVERDRAW: 1,  // extra pixels per side on edge strokes: stroke width = CELL_SIZE + EDGE_OVERDRAW * 2 (1 = 4px strokes)
  EDGE_ALPHA: 0.45,  // normal edge stroke opacity — soft glow, doesn't compete with gameplay elements
} as const;

// Cell material types (multi-material grid: 0=empty, 1=sand, 2=wireframe)
export const CELL = { EMPTY: 0, SAND: 1, WIREFRAME: 2 } as const;
